<template>
  <view class="pft-t-body" ref="bodyEl">
    <view class="pft-t-scroll-container" :style="containerStyle">
      <view class="pft-t-body-page" :style="pageStyle" flex="dir:top main:top" v-for="(list, index) of pagesItems" :key="index">
        <template v-for="(row, rowIndex) in list" :key="row.rowIndex">
          <CompareRowItem v-if="isCompare" :row="row" :compareRow="compareRow(row)" :rowIndex="rowIndex" :columns="columns" />
          <RowItem v-else :row="row" :rowIndex="rowIndex" :columns="columns" />
        </template>
      </view>
    </view>
  </view>
</template>

<script lang="ts" setup>
// TODO：props.compareData[rowIndex]是错的，需要重写
import { onMounted, inject, provide, ref, watch, useTemplateRef } from "vue"
import { defaultsDeep } from "lodash-es"
import RowItem from "../components/rowItem.vue"
import CompareRowItem from "../components/compareRowItem.vue"
import { useElementSize } from "@vueuse/core"
const el = useTemplateRef("bodyEl")
const RowHeight = inject("RowHeight") as any
const { height } = useElementSize(el as any)
const BodyHeight = height
const props = defineProps<{
  data: any[]
  isCompare?: boolean
  columns: any[]
  separated: boolean
  duration: number
}>()

const list = ref<{ [key: string]: string | number }[]>([])
const pagesItems = ref<{ [key: string]: string | number }[][]>([])

const getCompareRow = inject("getCompareRow") as (row: any) => any

const compareRow = (row: any) => {
  return getCompareRow(row)
}

watch(
  () => props.data,
  () => {
    list.value = props.data.map((item, index) => {
      item.rank = index + 1
      return item
    })
  },

  { immediate: true, deep: true },
)

const itemClass = (num: number, rank: number) => {
  const classObj = {
    "align-left": props.columns[num].align === "left",
    "align-right": props.columns[num].align === "right",
    dot: props.columns[num].listStyle === "dot",
    "separated-row": props.separated && rank % 2 === 0,
  }
  return classObj
}

const rowHeight = ref(32)

provide("itemClass", itemClass)

const itemStyle = (num: number, rowIndex: number) => {
  let defaultVal: any = {
    color: "#a3a6ad",
    height: "32px",
  }
  let style = props.columns[num].style
  if (style instanceof Function) {
    const dataItem = list.value[rowIndex]
    style = style(dataItem)
  }
  const newStyle = defaultsDeep({}, style, defaultVal)
  // console.log("newStyle", rowIndex, props.rows, newStyle)
  // if (rowIndex === props.rows) {
  //   newStyle.height = "0px"
  // }
  if (newStyle.height) {
    newStyle.lineHeight = newStyle.height
    rowHeight.value = Number(newStyle.height.replace("px", ""))
  }
  return newStyle
}

provide("itemStyle", itemStyle)

const RowsPerPage = ref(0)
const pages = ref(0)
const curPage = ref(0)
const pageStyle = ref<{ [key: string]: string }>({})
const containerStyle = ref<{ [key: string]: string }>({})

const animationTimer = ref<number>()
const startAnimation = () => {
  if (animationTimer.value) {
    clearInterval(animationTimer.value)
  }
  animationTimer.value = setInterval(() => {
    if (curPage.value === pages.value - 1) {
      curPage.value = 0
    } else {
      curPage.value++
    }
    containerStyle.value = {
      transform: `translateY(-${curPage.value * BodyHeight.value}px)`,
    }
  }, props.duration * 1000)
}

watch(
  [() => RowHeight.value, () => BodyHeight.value],
  () => {
    if (RowHeight.value === 0 || BodyHeight.value === 0) return
    RowsPerPage.value = Math.floor(BodyHeight.value / RowHeight.value)
    pages.value = Math.ceil(list.value.length / RowsPerPage.value)
    pagesItems.value = []
    for (let i = 0; i < pages.value; i++) {
      pagesItems.value.push(list.value.slice(i * RowsPerPage.value, (i + 1) * RowsPerPage.value))
    }
    pageStyle.value = {
      height: `${BodyHeight.value}px`,
    }
    console.log("RowHeight", RowHeight)
    console.log("BodyHeight", BodyHeight)
    console.log("RowsPerPage", RowsPerPage)
    startAnimation()
  },
  { immediate: true, deep: true },
)
</script>

<style lang="scss" scoped>
.pft-t-body {
  overflow: hidden !important;
}
.pft-t-scroll-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  // transform: translateY(-100px);
  transition: transform 0.5s ease-in-out;
}
.pft-t-body-page {
  width: 100%;
  flex-shrink: 0;
}
</style>
